import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, AlertTriangle, CheckCircle, Phone } from 'lucide-react';

export default function SafetyPage() {
  return (
    <Layout>
      <div className="container-app py-12 max-w-4xl">
        <div className="text-center mb-12">
          <Shield className="w-16 h-16 mx-auto mb-4 text-primary" />
          <h1 className="text-4xl font-bold mb-4">Sécurité & Recommandations</h1>
          <p className="text-lg text-muted-foreground">
            Votre sécurité est notre priorité. Suivez ces recommandations.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CheckCircle className="text-green-600" />
                Bonnes Pratiques
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">Rencontrez-vous dans des lieux publics</h3>
                <p className="text-muted-foreground">Pour un premier échange, privilégiez un lieu public et fréquenté.</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Vérifiez les profils</h3>
                <p className="text-muted-foreground">Consultez les avis et le niveau de vérification avant de réserver.</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Communiquez via la plateforme</h3>
                <p className="text-muted-foreground">Gardez une trace de vos échanges en utilisant la messagerie Oknî.</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Faites confiance à votre instinct</h3>
                <p className="text-muted-foreground">Si quelque chose vous semble suspect, n'hésitez pas à annuler.</p>
              </div>
            </CardContent>
          </Card>

          <Card className="rounded-2xl border-orange-500">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-orange-600">
                <AlertTriangle />
                Signaux d'Alerte
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">Demandes de paiement hors plateforme</h3>
                <p className="text-muted-foreground">Ne payez jamais en dehors du système de crédits Oknî.</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Comportements inappropriés</h3>
                <p className="text-muted-foreground">Harcèlement, propos déplacés : signalez immédiatement.</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Services illégaux</h3>
                <p className="text-muted-foreground">Toute proposition illégale doit être signalée.</p>
              </div>
            </CardContent>
          </Card>

          <Card className="rounded-2xl border-red-500">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-red-600">
                <Phone />
                En Cas d'Urgence
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-lg font-semibold">Si vous êtes en danger, contactez les services d'urgence :</p>
              <ul className="space-y-2">
                <li><strong>Police :</strong> 101</li>
                <li><strong>Urgences médicales :</strong> 112</li>
                <li><strong>Pompiers :</strong> 100</li>
              </ul>
              <p className="text-muted-foreground mt-4">
                Oknî n'est pas un service d'urgence. En cas de danger immédiat, appelez les autorités.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
